// // import React, { useState, useEffect } from "react";
// import "./dppsummary.css";
// import TableCompoenent from "../components/TableCompoenent";
// import DropDown from "../DummyReportPage/Dropdown";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import axios from "axios";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import React, { useState, useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";

// const StudentDPPSummary = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const [searchKey, setSearchKey] = useState(""); // Track the search key
//   const { state: routerState } = useRouterLocation();
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const { coursesdata } = useSelector((state) => state.course);
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     last_month: "",
//     month_to_date: "",
//     week_to_date: "",
//     custom: "",
//     recurrence: "",
//     start_month: "",
//     end_month: "",
//   });

//   const onChange = async (e) => {
//     const { name, value: inputValue, type } = e.target;
//     if (type === "radio" && name === "recurrence") {
//       setValues((prevState) => ({
//         ...prevState,
//         recurrence: inputValue,
//       }));
//     } else {
//       setValues((prevState) => ({
//         ...prevState,
//         [name]: inputValue,
//       }));
//     }
//   };
//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };
//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (!searchKey || !selectedCourseId || value.subject_id.length === 0) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };
//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };
//   const handleApplyOrReset = () => {
//     if (isApplied) {
//       // Reset state
//       setIsApplied(false);
//       setValues({
//         report_title: "",
//         course_id: "",
//         batch_id: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//       });
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers

//       // Force re-render of dropdowns
//       setResetKey((prevKey) => prevKey + 1);
//     } else {
//       // Apply state
//       setIsApplied(true);
//       fetchResultsData();
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   // const handleCancel = () => {
//   //   setIsMessageBoxVisible(true);
//   //   setMessageBox("Are you sure you want to cancel?");
//   //   setTimeout(function () {
//   //     setIsMessageBoxVisible(false);
//   //   }, 9000);
//   //   setActiveImg(InterogativeImg);
//   // };

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "82vw",
//           marginTop: "2.3vh",
//         }}
//       >
//         <div style={{ display: "flex", width: "50vw" }}>
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Are you sure you want to cancel?
//           </span>
//         </div>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             width: "100%",
//           }}
//         >
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)} // Close the messagebox on Cancel
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()} // Reload the page on Proceed
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student DPP Summary
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             {/* <button
//               className="testreportcard-cancel-btn"
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button> */}
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter reports. View and manage the list of reports
//           already available or create a new report.
//         </p>

//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDownCB
//               label="Course"
//               style={{ width: "13.5vw" }}
//               selected={selectedCourseId}
//               setSelected={setSelectedCourseId}
//               options={
//                 coursesdata
//                   ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                   : []
//               }
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDown
//               label="Batch"
//               setSelected={(selectedOption) =>
//                 setValues({ ...value, batch_id: selectedOption })
//               }
//               options={batchData.map((batch) => ({
//                 label: batch.batch_code,
//                 id: batch.batch_id,
//               }))}
//               Height="auto"
//               OverFlow="auto"
//               minheight="300px"
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDown
//               label="Student"
//               setSelected={(selectedOption) =>
//                 setValues({ ...value, batch_id: selectedOption })
//               }
//               options={batchData.map((batch) => ({
//                 label: batch.batch_code,
//                 id: batch.batch_id,
//               }))}
//               Height="auto"
//               OverFlow="auto"
//               minheight="300px"
//             />
//           </div>
//         </div>
//         <div
//           className="col-cs2"
//           style={{ marginRight: "1vw", ...dropdownStyle }}
//           key={`test_${resetKey}`}
//         >
//           <DropDownMultipleSelection
//             label="Subject"
//             width="13.5vw"
//             selected={value.subject_id}
//             setSelected={(selectedOptions) =>
//               setValues({ ...value, subject_id: selectedOptions })
//             }
//             options={subjectData}
//             showSelectAll={true}
//           />
//         </div>
//         <div
//           className="col-cs2"
//           style={{ marginRight: "1vw", ...dropdownStyle }}
//           key={`test_${resetKey}`}
//         >
//           <DropDownMultipleSearchSelection
//             label="Chapter"
//             width="13.5vw"
//             customWidth="25vw"
//             selected={value.chapter_id}
//             setSelected={(selectedOptions) =>
//               setValues({ ...value, chapter_id: selectedOptions })
//             }
//             fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//             options={chapterData} // Use the formatted data with subject, chapter, and course
//           />
//         </div>
//         <div
//           className="grid-container-radio-button"
//           style={{ height: "40px", ...dropdownStyle }}
//         >
//           <div className="item5">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="last month"
//                 name="month"
//                 value="Last Month"
//                 checked={value.month === "Last Month"}
//                 onChange={onChange}
//                 // disabled={disabled}
//               />
//               <label htmlFor="last month">Last Month</label>
//             </div>
//           </div>
//           <div className="item6">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="month to date"
//                 name="month"
//                 value="Month to Date"
//                 checked={value.month === "Month to Date"}
//                 onChange={onChange}
//                 // disabled={disabled}
//               />
//               <label htmlFor="month to date">Month to Date</label>
//             </div>
//           </div>
//           <div className="item7">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="week to date"
//                 name="month"
//                 value="Week to Date"
//                 checked={value.month === "Week to Date"}
//                 onChange={onChange}
//                 // disabled={disabled}
//               />
//               <label htmlFor="week to date">Week to Date</label>
//             </div>
//           </div>
//           <div className="item8">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="custom"
//                 name="month"
//                 value="Custom"
//                 checked={value.month === "Custom"}
//                 onChange={onChange}
//                 // disabled={disabled}
//               />
//               <label htmlFor="custom">Custom</label>
//             </div>
//           </div>
//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs
//                   type="month"
//                   name="start_month"
//                   value={value.start_month}
//                   onChange={onChange}
//                   // disabled={disabled}
//                 />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs
//                   type="month"
//                   name="end_month"
//                   value={value.end_month}
//                   onChange={onChange}
//                   // disabled={disabled}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//         <TableCompoenent
//           headers={headers}
//           data={data}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//         />
//       </div>
//       <div></div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect } from "react";
// import "./dppsummary.css";
// import TableComponent from "../components/TableCompoenent";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";

// const StudentDPPSummary = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { state: routerState } = useRouterLocation();
//   const [searchKeySecond, setSearchKeySecond] = useState("");

//   // State variables
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const { coursesdata } = useSelector((state) => state.course);
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [searchResults, setSearchResults] = useState([]);
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [disabled, setDisabled] = useState(false);
//   const [selectedStudentIds, setSelectedStudentIds] = useState([]);

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     last_month: "",
//     month_to_date: "",
//     week_to_date: "",
//     custom: "",
//     recurrence: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [], // Ensure this is initialized as an array
//     chapter_id: [], // Ensure this is initialized as an array
//   });

//   // Fetch course data on mount
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch subjects and batches when selectedCourseId changes
//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchSubjectsByCourse();
//       fetchBatchesByCourse();
//     }
//   }, [selectedCourseId]); // Trigger when selectedCourseId changes
//   // Fetch subjects by selected course ID
//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Fetch batches by selected course ID
//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return;

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Fetch students based on the search key and batch IDs
//   const fetchStudentsByBatchAndSearchKey = async (searchKey) => {
//     if (searchKey && searchKey.length >= 3 && selectedBatchIds.length > 0) {
//       try {
//         const batchIdsQuery = selectedBatchIds
//           .map((id) => `batch_ids=${id}`)
//           .join("&");
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKey}&${batchIdsQuery}`,
//           {
//             method: "GET",
//             headers: {
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         return data.map((student) => ({
//           label: student.student_name,
//           id: student.student_id, // Student ID to be saved
//           Option1: student.student_name, // For displaying student name
//           Option2: student.student_roll_no, // For displaying roll number
//         }));
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         return [];
//       }
//     } else {
//       return [];
//     }
//   };

//   // Handle student selection
//   const handleStudentSelect = (selectedStudentIds) => {
//     setSelectedStudentIds(selectedStudentIds); // Save selected student IDs
//     console.log("Selected student IDs:", selectedStudentIds);
//   };

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (!searchKey || !selectedCourseId || value.subject_id.length === 0) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };

//   // Handle radio button change
//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   // Handle custom date range change
//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   // Handle Apply or Reset button logic
//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       setIsApplied(false);
//       setValues({
//         report_title: "",
//         course_id: "",
//         batch_id: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//         subject_id: [], // Reset subject_id to an empty array
//         chapter_id: [], // Reset chapter_id to an empty array
//       });
//       setResultsData([]);
//       setHeaders([]);
//       setResetKey((prevKey) => prevKey + 1);
//     } else {
//       setIsApplied(true);

//       // Determine from_date and end_date based on the selected date range
//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         // Default to an empty date range if nothing is selected
//         from_date = from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         ); // Replace with a default date if necessary
//         // end_date = "2024-09-14"; // Replace with a default date if necessary
//       }

//       // Append static time directly to the formatted date
//       const from_date_with_time = `${from_date} 10:46:01.000`;
//       const end_date_with_time = `${end_date} 10:46:01.000`;

//       // POST data to API
//       const postData = {
//         batch_ids: selectedBatchIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//         assessment_ids: [], // Include if there are any assessment IDs to pass
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//             from_date_with_time
//           )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );
//         const data = await response.json();

//         if (data && data.length > 0) {
//           setHeaders(data[0]); // Assuming first row contains headers
//           setResultsData(data.slice(1)); // Remaining rows are data
//         } else {
//           setResultsData([]);
//           Swal.fire({
//             title: "No Data Found",
//             text: "No records matched your filters.",
//             icon: "info",
//             confirmButtonText: "OK",
//           });
//         }
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   // Handle cancel operation
//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "82vw",
//           marginTop: "2.3vh",
//         }}
//       >
//         <div style={{ display: "flex", width: "50vw" }}>
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Are you sure you want to cancel?
//           </span>
//         </div>
//         <div
//           style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
//         >
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Student DPP Summary
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button>
//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter reports. View and manage the list of reports
//           already available or create a new report.
//         </p>

//         {/* Dropdowns */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDownCB
//               label="Course"
//               style={{ width: "13.5vw" }}
//               selected={selectedCourseId}
//               setSelected={setSelectedCourseId}
//               options={
//                 coursesdata
//                   ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                   : []
//               }
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               label="Batch"
//               width="13.5vw"
//               selected={selectedBatchIds}
//               setSelected={setSelectedBatchIds}
//               options={batchData.map((batch) => ({
//                 label: batch.batch_name,
//                 id: batch.batch_id,
//               }))}
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDownMultipleSearchSelection
//               label="Search Student"
//               width="20.7vw"
//               customWidth="25vw"
//               selected={selectedStudentIds}
//               setSelected={handleStudentSelect}
//               fetchOptions={fetchStudentsByBatchAndSearchKey}
//               options={searchResults}
//             />
//           </div>
//         </div>
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`test_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               label="Subject"
//               width="13.5vw"
//               selected={value.subject_id}
//               setSelected={(selectedOptions) =>
//                 setValues({ ...value, subject_id: selectedOptions })
//               }
//               options={subjectData}
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`chapter_${resetKey}`}
//           >
//             <DropDownMultipleSearchSelection
//               label="Chapter"
//               width="13.5vw"
//               customWidth="25vw"
//               selected={value.chapter_id}
//               setSelected={(selectedOptions) =>
//                 setValues({ ...value, chapter_id: selectedOptions })
//               }
//               fetchOptions={fetchChaptersByCourseAndSubject}
//               options={chapterData}
//             />
//           </div>
//         </div>
//         {/* Date Range and Table Component */}
//         <div
//           className="grid-container-radio-button"
//           style={{ ...dropdownStyle }}
//         >
//           <div className="item5">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="last month"
//                 name="month"
//                 value="Last Month"
//                 checked={value.month === "Last Month"}
//                 onChange={() => handleRadioButtonChange("Last Month")}
//                 disabled={disabled}
//               />
//               <label htmlFor="last month">Last Month</label>
//             </div>
//           </div>
//           <div className="item6">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="month to date"
//                 name="month"
//                 value="Month to Date"
//                 checked={value.month === "Month to Date"}
//                 onChange={() => handleRadioButtonChange("Month to Date")}
//                 disabled={disabled}
//               />
//               <label htmlFor="month to date">Month to Date</label>
//             </div>
//           </div>
//           <div className="item7">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="week to date"
//                 name="month"
//                 value="Week to Date"
//                 checked={value.month === "Week to Date"}
//                 onChange={() => handleRadioButtonChange("Week to Date")}
//                 disabled={disabled}
//               />
//               <label htmlFor="week to date">Week to Date</label>
//             </div>
//           </div>
//           <div className="item8">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="custom"
//                 name="month"
//                 value="Custom"
//                 checked={value.month === "Custom"}
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={disabled}
//               />
//               <label htmlFor="custom">Custom</label>
//             </div>
//           </div>
//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs
//                   type="month"
//                   name="start_month"
//                   value={value.start_month}
//                   onChange={(e) => handleCustomRangeChange(e, "start_month")}
//                   disabled={disabled}
//                 />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs
//                   type="month"
//                   name="end_month"
//                   value={value.end_month}
//                   onChange={(e) => handleCustomRangeChange(e, "end_month")}
//                   disabled={disabled}
//                 />
//               </div>
//             </>
//           )}
//         </div>

//         {/* Table Component */}
//         <TableComponent
//           headers={headers}
//           data={data}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect } from "react";
// import "./dppsummary.css";
// import TableComponent from "../components/TableCompoenent";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";
// import { useNavigate } from "react-router-dom";

// const StudentDPPSummary = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { state: routerState } = useRouterLocation();
//   const [searchKeySecond, setSearchKeySecond] = useState("");
//   const navigate = useNavigate();
//   const [BorderControl, setBorderControl] = useState(false);
//   // State variables
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const { coursesdata } = useSelector((state) => state.course);

//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [searchResults, setSearchResults] = useState([]);
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [disabled, setDisabled] = useState(false);
//   const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//   const [isVisible, setIsVisible] = useState(true); // Default to visible
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
//   const [studentData, setStudentData] = useState([]); // State for students
//   const [dppData, setDppData] = useState([]); // State for DPP names
//   // const [selectedStudentIds, setSelectedStudentIds] = useState([]); // Selected student IDs
//   const [selectedBatchDetails, setSelectedBatchDetails] = useState({}); // Store batch, subject, and chapter details

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: [],
//     assessment_name: "",
//     description: "",
//     last_month: "",
//     month_to_date: "",
//     month: "Month to Date",
//     week_to_date: "",
//     custom: "",
//     recurrence: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [], // Ensure this is initialized as an array
//     chapter_id: [], // Ensure this is initialized as an array
//   });
//   // const [value, setValues] = useState({
//   //   report_title: "",
//   //   course_id: "",
//   //   batch_id: "",
//   //   assessment_id: "",
//   //   assessment_name: "",
//   //   description: "",
//   //   month: "Month to Date", // Set "Month to Date" as the default value
//   //   start_month: "",
//   //   end_month: "",
//   //   subject_id: [],
//   //   chapter_id: [],
//   // });

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   // Fetch course data on mount
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch subjects and batches when selectedCourseId changes
//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchSubjectsByCourse();
//       fetchBatchesByCourse();
//     }
//   }, [selectedCourseId]); // Trigger when selectedCourseId changes
//   // Fetch subjects by selected course ID
//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       // Swal.fire({
//       //   title: "Error!",
//       //   text: error.message,
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//           onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   // Fetch batches by selected course ID
//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return;

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data);
//     } catch (error) {
//       // Swal.fire({
//       //   title: "Error!",
//       //   text: error.message,
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//           onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   // Fetch students based on the search key and batch IDs
//   // const fetchStudentsByBatchAndSearchKey = async (searchKey) => {
//   //   if (searchKey && searchKey.length >= 3 && selectedBatchIds.length > 0) {
//   //     try {
//   //       const batchIdsQuery = selectedBatchIds
//   //         .map((id) => `batch_ids=${id}`)
//   //         .join("&");
//   //       const response = await fetch(
//   //         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKey}&${batchIdsQuery}`,

//   //         {
//   //           method: "GET",
//   //           headers: {
//   //             accept: "application/json",
//   //           },
//   //         }
//   //       );
//   //       const data = await response.json();
//   //       return data.map((student) => ({
//   //         label: student.student_name,
//   //         id: student.student_id, // Student ID to be saved
//   //         Option1: student.student_name, // For displaying student name
//   //         Option2: student.student_roll_no, // For displaying roll number
//   //       }));
//   //     } catch (error) {
//   //       // Swal.fire({
//   //       //   title: "Error!",
//   //       //   text: error.message,
//   //       //   icon: "error",
//   //       //   confirmButtonText: "OK",
//   //       // });
//   //       setIsMessageBoxVisible(true);
//   //       setMessageBox(
//   //         <div
//   //           className="Container-messageBOX"
//   //           onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//   //           onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//   //         >
//   //           <div className="messagebox-insider1">
//   //             <div className="loader-tc"></div>
//   //             <span>{error.message}</span>
//   //           </div>
//   //         </div>
//   //       );
//   //       setActiveImg(InterogativeImg);
//   //       return [];
//   //     }
//   //   } else {
//   //     return [];
//   //   }
//   // };

//   // Fetch students and DPP based on the search key and batch IDs
//   // const [selectedStudentIds, setSelectedStudentIds] = useState([]); // Store selected student IDs
//   // const [batchIds, setBatchIds] = useState([]); // Assuming you have a way to manage selected batchIds

//   // // Function to fetch students and DPPs based on search key and batch IDs
//   // const fetchStudentsAndDppByBatch = async (searchKey) => {
//   //   if (searchKey && searchKey.length >= 3) {
//   //     // Only call API if search key is at least 3 characters
//   //     try {
//   //       const response = await fetch(
//   //         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKey}`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             accept: "application/json",
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify(batchIds.length > 0 ? batchIds : []),
//   //         }
//   //       );

//   //       if (!response.ok) {
//   //         throw new Error("Failed to fetch data");
//   //       }

//   //       const data = await response.json();

//   //       // Process students and dpp_list from the API response
//   //       const students = Array.isArray(data.students)
//   //         ? data.students.map((student) => ({
//   //             id: student.student_id,
//   //             Option1: student.student_name,
//   //             Option2: student.student_roll_no,
//   //             Option3: student.course_name,
//   //             Headers1: "Student Name", // Define headers for dropdown
//   //             Headers2: "Roll No",
//   //             Headers3: "Course Name",
//   //           }))
//   //         : [];

//   //       return students; // Return the processed students to be used in the dropdown
//   //     } catch (error) {
//   //       console.error("Error fetching students and DPPs:", error);
//   //       return []; // Return empty array on error
//   //     }
//   //   } else {
//   //     return []; // Return empty array if searchKey is too short
//   //   }
//   // };
//   // useEffect(() => {
//   //   if (debouncedSearchTerm.length >= 3) {
//   //     fetchOptions(debouncedSearchTerm).then((options) => {
//   //       setFilteredOptions(options);
//   //     });
//   //   }
//   // }, [debouncedSearchTerm, fetchOptions]);

//   // Handle student selection
//   // const handleStudentSelect = (selectedStudent) => {
//   //   if (selectedStudent && Array.isArray(selectedStudent)) {
//   //     setSelectedStudentIds(selectedStudent.map((student) => student.id)); // Save selected student IDs
//   //   } else if (selectedStudent) {
//   //     setSelectedStudentIds([selectedStudent.id]); // Handle single selection
//   //   } else {
//   //     setSelectedStudentIds([]); // Handle no selection
//   //   }
//   // };
//   // const fetchChaptersByFilter = async (searchKey) => {
//   //   if (!searchKey || searchKey.length < 3 || !selectedCourseId) {
//   //     return Promise.resolve([]);
//   //   }

//   //   try {
//   //     const response = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${selectedCourseId}&search_key=${searchKey}&search_cloumn=chapter`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({
//   //           batch_ids: selectedBatchIds, // Batch IDs selected from the dropdown
//   //           assessment_ids: value.assessment_id, // Assessment IDs if available
//   //           subject_ids: value.subject_id, // Subject IDs
//   //           chapter_ids: value.chapter_id, // Chapter IDs
//   //         }),
//   //       }
//   //     );
//   //     const data = await response.json();

//   //     return data.map((item) => ({
//   //       label: item.chapter_name,
//   //       id: item.chapter_id,
//   //       batch_name: item.batch_name, // Additional data from the response
//   //       subject_name: item.subject_name,
//   //       assessment_name: item.assessment_name,
//   //       Option1: item.chapter_name,
//   //       Option2: item.subject_name,
//   //       Option3: item.course_name,
//   //       Headers1: "Chapter Name",
//   //       Headers2: "Subject Name",
//   //       Headers3: "Course Name",
//   //     }));
//   //   } catch (error) {
//   //     console.error("Error fetching chapters:", error);
//   //     return [];
//   //   }
//   // };
//   // const fetchChaptersByFilter = async (searchKey) => {
//   //   if (!searchKey || searchKey.length < 3 || !selectedCourseId) {
//   //     return Promise.resolve([]);
//   //   }

//   //   try {
//   //     const response = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${selectedCourseId}&search_key=${searchKey}&search_cloumn=chapter`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({
//   //           batch_ids: selectedBatchIds,
//   //           assessment_ids: value.assessment_id,
//   //           subject_ids: value.subject_id,
//   //           chapter_ids: value.chapter_id,
//   //         }),
//   //       }
//   //     );
//   //     const data = await response.json();

//   //     // Map using unique assessment_assignment_id
//   //     return data.map((item) => ({
//   //       label: item.chapter_name,
//   //       id: item.chapter_id,
//   //       assessment_assignment_id: item.assessment_assignment_id, // Unique field
//   //       batch_name: item.batch_name,
//   //       subject_name: item.subject_name,
//   //       assessment_name: item.assessment_name,
//   //       Option1: item.chapter_name,
//   //       Option2: item.subject_name,
//   //       Option3: item.course_name,
//   //       Headers1: "Chapter Name",
//   //       Headers2: "Subject Name",
//   //       Headers3: "Course Name",
//   //     }));
//   //   } catch (error) {
//   //     console.error("Error fetching chapters:", error);
//   //     return [];
//   //   }
//   // };

//   // // const [chapterData, setChapterData] = useState([]);
//   // const [assessmentDetails, setAssessmentDetails] = useState([]); // Store assessment data

//   // const handleChapterData = async (searchKey) => {
//   //   const chapters = await fetchChaptersByFilter(searchKey);

//   //   setChapterData(chapters); // Store chapter data, including assessment_assignment_id
//   //   setAssessmentDetails(
//   //     chapters.map((chapter) => ({
//   //       assessment_assignment_id: chapter.assessment_assignment_id, // Use this for uniqueness
//   //       assessment_name: chapter.assessment_name,
//   //       batch_id: chapter.batch_id,
//   //       batch_name: chapter.batch_name,
//   //       subject_id: chapter.subject_id,
//   //       subject_name: chapter.subject_name,
//   //     }))
//   //   );
//   // };
//   const fetchStudentsAndDppByBatch = async (searchKey) => {
//     if (searchKey && searchKey.length >= 3) {
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKey}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(selectedBatchIds.length > 0 ? selectedBatchIds : []), // Use selectedBatchIds here
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch data");
//         }

//         const data = await response.json();

//         const students = Array.isArray(data.students)
//           ? data.students.map((student) => ({
//               id: student.student_id,
//               Option1: student.student_name,
//               Option2: student.student_roll_no,
//               Option3: student.course_name,
//               Headers1: "Student Name",
//               Headers2: "Roll No",
//               Headers3: "Course Name",
//             }))
//           : [];

//         return students; // Return the processed students to be used in the dropdown
//       } catch (error) {
//         console.error("Error fetching students and DPPs:", error);
//         return []; // Return empty array on error
//       }
//     } else {
//       return []; // Return empty array if searchKey is too short
//     }
//   };

//   // const fetchChaptersByFilter = async (searchKey) => {
//   //   if (!searchKey || searchKey.length < 3 || !selectedCourseId) {
//   //     return Promise.resolve([]); // No API call if search key is too short or course not selected
//   //   }

//   //   try {
//   //     const response = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${selectedCourseId}&search_key=${searchKey}&search_cloumn=chapter`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({
//   //           batch_ids: selectedBatchIds,
//   //           assessment_ids: value.assessment_id,
//   //           subject_ids: value.subject_id,
//   //           chapter_ids: value.chapter_id,
//   //         }),
//   //       }
//   //     );

//   //     const data = await response.json();

//   //     return data.map((item) => ({
//   //       label: item.chapter_name,
//   //       id: item.chapter_id,
//   //       assessment_assignment_id: item.assessment_assignment_id,
//   //       batch_name: item.batch_name,
//   //       subject_name: item.subject_name,
//   //       assessment_name: item.assessment_name,
//   //       Option1: item.chapter_name,
//   //       Option2: item.subject_name,
//   //       Option3: item.course_name,
//   //       Headers1: "Chapter Name",
//   //       Headers2: "Subject Name",
//   //       Headers3: "Course Name",
//   //     }));
//   //   } catch (error) {
//   //     console.error("Error fetching chapters:", error);
//   //     return [];
//   //   }
//   // };

//   const fetchChaptersByFilter = async (searchKey) => {
//     if (!searchKey && searchKey.length < 3 && !selectedCourseId) {
//       return Promise.resolve([]); // No API call if search key is too short or course not selected
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${selectedCourseId}&search_key=${searchKey}&search_cloumn=chapter`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatchIds,
//             assessment_ids: value.assessment_id,
//             subject_ids: value.subject_id,
//             chapter_ids: value.chapter_id,
//           }),
//         }
//       );

//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         assessment_assignment_id: item.assessment_assignment_id,
//         batch_name: item.batch_name,
//         subject_name: item.subject_name,
//         assessment_name: item.assessment_name,
//         Option1: item.chapter_name,
//         Option2: item.subject_name,
//         Option3: item.course_name,
//         Headers1: "Chapter Name",
//         Headers2: "Subject Name",
//         Headers3: "Course Name",
//       }));
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };
//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset only table data and headers
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Optionally hide the column div if needed
//     } else {
//       // Apply logic
//       setIsApplied(true);
//       setDisabled(true);

//       let from_date, end_date;
//       const today = new Date();
//       const staticTime = "10:46:01.000";

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       }

//       const from_date_with_time = `${from_date} ${staticTime}`;
//       const end_date_with_time = `${end_date} ${staticTime}`;

//       const postData = {
//         batch_ids: selectedBatchIds,
//         student_ids: selectedStudentIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//             from_date_with_time
//           )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();
//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           setResultsData([]); // Ensure table data is cleared if no results
//           // Swal.fire({
//           //   title: "No Data Found",
//           //   text: "No results found for the selected filters.",
//           //   icon: "warning",
//           //   confirmButtonText: "OK",
//           // });
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div
//               className="Container-messageBOX"
//               onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//               onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//             >
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>No results found for the selected filters.</span>
//               </div>
//               <div className="messagebox-insider2">
//                 <button
//                   className="testreportcard-create-btn"
//                   onClick={() => setIsMessageBoxVisible(false)}
//                 >
//                   PROCEED
//                 </button>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//         // setIsColumnDivVisible(true); // Show table when data is available
//       } catch (error) {
//         // Swal.fire({
//         //   title: "Error",
//         //   text: error.message,
//         //   icon: "error",
//         //   confirmButtonText: "OK",
//         // });
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//             onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//             <div className="messagebox-insider2">
//               <button
//                 className="messagebox-cancel-btn"
//                 style={{ marginRight: "10px" }}
//                 onClick={() => setIsMessageBoxVisible(false)}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="testreportcard-create-btn"
//                 onClick={() => window.location.reload()}
//               >
//                 PROCEED
//               </button>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     }
//   };

//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   // Handle cancel operation
//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "82vw",
//           marginTop: "2.3vh",
//         }}
//       >
//         <div style={{ display: "flex", width: "50vw" }}>
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Are you sure you want to cancel?
//           </span>
//         </div>
//         <div
//           style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
//         >
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//             // <button onClick={() => navigate(-1)}>Go Back</button>
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   const course =
//     coursesdata && coursesdata.length > 0
//       ? coursesdata.find((course) => course.course_id === selectedCourseId)
//           ?.course_description || ""
//       : "";

//   const maxBatchLength = 136;
//   const batch = (() => {
//     if (
//       selectedBatchIds.length === 0 ||
//       selectedBatchIds.length === batchData.length
//     ) {
//       return "All"; // Case when no batches or all batches are selected
//     }

//     const batchString = batchData
//       .filter((batch) => selectedBatchIds.includes(batch.batch_id))
//       .map((batch) => batch.batch_name)
//       .join(", ");

//     if (batchString.length > maxBatchLength) {
//       return "Multiple";
//     } else {
//       return batchString;
//     }
//   })();

//   const maxStudentLength = 136;
//   const students = (() => {
//     if (
//       selectedStudentIds.length === 0 ||
//       selectedStudentIds.length === searchResults.length
//     ) {
//       return "All"; // Case when no students or all students are selected
//     }

//     const studentString = searchResults
//       .filter((student) => selectedStudentIds.includes(student.id))
//       .map((student) => student.label)
//       .join(", ");

//     if (studentString.length > maxStudentLength) {
//       return "Multiple";
//     } else {
//       return studentString;
//     }
//   })();

//   const maxSubjectLength = 136;
//   const subject = (() => {
//     if (
//       value.subject_id.length === 0 ||
//       value.subject_id.length === subjectData.length
//     ) {
//       return "All"; // Case when no subjects or all subjects are selected
//     }

//     const subjectString = subjectData
//       .filter((subject) => value.subject_id.includes(subject.id))
//       .map((subject) => subject.label)
//       .join(", ");

//     if (subjectString.length > maxSubjectLength) {
//       return "Multiple";
//     } else {
//       return subjectString;
//     }
//   })();

//   const maxChapterLength = 136;
//   const chapter = (() => {
//     if (
//       value.chapter_id.length === 0 ||
//       value.chapter_id.length === chapterData.length
//     ) {
//       return "All"; // Case when no chapters or all chapters are selected
//     }

//     const chapterString = chapterData
//       .filter((chapter) => value.chapter_id.includes(chapter.id))
//       .map((chapter) => chapter.label)
//       .join(", ");

//     if (chapterString.length > maxChapterLength) {
//       return "Multiple";
//     } else {
//       return chapterString;
//     }
//   })();

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             DPP status summary
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               // onClick={handleCancel}
//               onClick={() => navigate(-1)}
//             >
//               CANCEL
//             </button>
//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//             View, create, or filter reports. View and manage the list of reports
//             already available or create a new report.
//           </p>

//           {/* Dropdowns */}
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                         id: course.course_id,
//                         label: course.course_description,
//                       }))
//                     : []
//                 }
//                 isUnique={BorderControl} // Pass the boolean value here to switch between classes
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Batch"
//                 width="13.5vw"
//                 selected={selectedBatchIds}
//                 setSelected={setSelectedBatchIds}
//                 options={batchData.map((batch) => ({
//                   label: batch.batch_name,
//                   id: batch.batch_id,
//                 }))}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`student_${resetKey}`}
//             >
//               {/* <DropDownMultipleSearchSelection
//                 label="Search Student"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={selectedStudentIds}
//                 setSelected={handleStudentSelect}
//                 fetchOptions={fetchStudentsByBatchAndSearchKey}
//                 options={searchResults}
//                 showSelectAll={true}
//               /> */}
//               <DropDownMultipleSearchSelection
//                 width="13.5vw"
//                 customWidth="25vw"
//                 label="Search Student"
//                 selected={selectedStudentIds} // Pass selected student IDs
//                 setSelected={setSelectedStudentIds} // Function to update selected student IDs
//                 fetchOptions={fetchStudentsAndDppByBatch} // Function to fetch student data from API
//                 showSelectAll={true} // Optionally show "Select All" checkbox
//               />
//             </div>
//           </div>
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`test_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Subject"
//                 width="13.5vw"
//                 selected={value.subject_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, subject_id: selectedOptions })
//                 }
//                 options={subjectData}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="Chapter"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={value.chapter_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, chapter_id: selectedOptions })
//                 }
//                 fetchOptions={fetchChaptersByFilter}
//                 options={chapterData}
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//         </div>
//         {/* Date Range and Table Component */}
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div
//             className="grid-container-radio-button"
//             style={{ ...dropdownStyle }}
//           >
//             <div className="item5">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="last month"
//                   name="month"
//                   value="Last Month"
//                   checked={value.month === "Last Month"}
//                   onChange={() => handleRadioButtonChange("Last Month")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="last month">Last Month</label>
//               </div>
//             </div>
//             <div className="item6">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="month to date"
//                   name="month"
//                   value="Month to Date"
//                   checked={value.month === "Month to Date"}
//                   onChange={() => handleRadioButtonChange("Month to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="month to date">Month to Date</label>
//               </div>
//             </div>
//             <div className="item7">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="week to date"
//                   name="month"
//                   value="Week to Date"
//                   checked={value.month === "Week to Date"}
//                   onChange={() => handleRadioButtonChange("Week to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="week to date">Week to Date</label>
//               </div>
//             </div>
//             <div className="item8">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="custom"
//                   name="month"
//                   value="Custom"
//                   checked={value.month === "Custom"}
//                   onChange={(e) =>
//                     setValues({ ...value, month: e.target.value })
//                   }
//                   disabled={disabled}
//                 />
//                 <label htmlFor="custom">Custom</label>
//               </div>
//             </div>
//             {/* {value.month === "Custom" && (
//               <>
//                 <div className="item9">
//                   <FormInputs
//                     type="month"
//                     name="start_month"
//                     value={value.start_month}
//                     onChange={(e) => handleCustomRangeChange(e, "start_month")}
//                     disabled={disabled}
//                   />
//                 </div>
//                 <div className="item10">To</div>
//                 <div className="item11">
//                   <FormInputs
//                     type="month"
//                     name="end_month"
//                     value={value.end_month}
//                     onChange={(e) => handleCustomRangeChange(e, "end_month")}
//                     disabled={disabled}
//                   />
//                 </div>
//               </>
//             )} */}
//             {value.month === "Custom" && (
//               <>
//                 <div className="item9">
//                   <FormInputs
//                     type="date"
//                     name="start_month"
//                     value={value.start_month}
//                     onChange={(e) =>
//                       setValues({ ...value, start_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//                 <div className="item10">To</div>
//                 <div className="item11">
//                   <FormInputs
//                     type="date"
//                     name="end_month"
//                     value={value.end_month}
//                     onChange={(e) =>
//                       setValues({ ...value, end_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               // borderTopLeftRadius: "100px",
//               // borderTopRightRadius: "100px",
//               border: "none",
//               // borderBottom: "0px !important",
//             }}
//             onClick={() => {
//               setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
//               setIsVisible(!isVisible);
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>

//           <TableComponent
//             headers={headers.map((header) => header.substring(2))} // Pass headers state
//             data={resultsData} // Pass the processed API data
//             searchPlaceholder="Search by Student Name..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded} // Pass the new isExpanded prop
//             ReportPageHeader="Student DPP Summary"
//             course={course}
//             batch={batch}
//             student={students}
//             subject={subject}
//             chapter={chapter}
//             dppName={""}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect, useCallback, memo } from "react";
// import "./dppsummary.css";
// import TableComponent from "../components/TableCompoenent";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// const StudentDPPSummary = memo(
//   ({
//     setMessageBox,
//     setIsMessageBoxVisible,
//     setActiveImg,
//     pauseTimer,
//     resumeTimer,
//     dataClient,
//   }) => {
//     const dispatch = useDispatch();
//     const { state: routerState } = useRouterLocation();
//     const [searchKeySecond, setSearchKeySecond] = useState("");
//     const navigate = useNavigate();
//     const [BorderControl, setBorderControl] = useState(false);
//     // State variables
//     const [batchData, setBatchData] = useState([]);
//     const [testnamedata, setTestNameData] = useState([]);
//     const [resultsData, setResultsData] = useState([]); // For storing API results
//     const [headers, setHeaders] = useState([]); // For storing table headers
//     const [isApplied, setIsApplied] = useState(false);
//     const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//     const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//     const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//     const { coursesdata } = useSelector((state) => state.course);

//     const [chapterData, setChapterData] = useState([]); // State for chapters
//     const [subjectData, setSubjectData] = useState([]); // State for subjects
//     const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//     const [searchResults, setSearchResults] = useState([]);
//     const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//     const [disabled, setDisabled] = useState(false);
//     const [selectedStudentIds, setSelectedStudentIds] = useState([]);
//     const [isVisible, setIsVisible] = useState(true); // Default to visible
//     const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
//     const [studentData, setStudentData] = useState([]); // State for students
//     const [dppData, setDppData] = useState([]); // State for DPP names
//     const [selectedBatchDetails, setSelectedBatchDetails] = useState({}); // Store batch, subject, and chapter details
//     const [selectedChapters, setSelectedChapters] = useState([]);
//     const [chapterOptions, setChapterOptions] = useState([]);

//     const [value, setValues] = useState({
//       report_title: "",
//       course_id: "",
//       batch_id: "",
//       assessment_id: [],
//       assessment_name: "",
//       description: "",
//       last_month: "",
//       month_to_date: "",
//       month: "Month to Date",
//       week_to_date: "",
//       custom: "",
//       recurrence: "",
//       start_month: "",
//       end_month: "",
//       subject_id: [], // Ensure this is initialized as an array
//       chapter_id: [], // Ensure this is initialized as an array
//     });

//     useEffect(() => {
//       const today = new Date();
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     }, []);

//     // Fetch course data on mount
//     useEffect(() => {
//       dispatch(fetchCourseData());
//     }, [dispatch]);

//     // Fetch subjects and batches when selectedCourseId changes
//     useEffect(() => {
//       if (selectedCourseId) {
//         fetchSubjectsByCourse();
//         fetchBatchesByCourse();
//       }
//     }, [selectedCourseId]); // Trigger when selectedCourseId changes
//     // Fetch subjects by selected course ID
//     const fetchSubjectsByCourse = async () => {
//       if (!selectedCourseId) return; // Ensure a single course_id is selected

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//         );
//         const data = await response.json();
//         const formattedData = data.map((item) => ({
//           label: item.subject_name,
//           id: item.subject_id,
//         }));
//         setSubjectData(formattedData);
//       } catch (error) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//             onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     };

//     // Fetch batches by selected course ID
//     const fetchBatchesByCourse = async () => {
//       if (!selectedCourseId) return;

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//         );
//         const data = await response.json();
//         setBatchData(data);
//       } catch (error) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer}
//             onMouseLeave={resumeTimer}
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     };

//     const fetchStudentsAndDppByBatch = async (searchKey) => {
//       if (searchKey && searchKey.length >= 3) {
//         try {
//           const response = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-searchkey-report-filter/?search_key=${searchKey}`,
//             {
//               method: "POST",
//               headers: {
//                 accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify(
//                 selectedBatchIds.length > 0 ? selectedBatchIds : []
//               ), // Use selectedBatchIds here
//             }
//           );

//           if (!response.ok) {
//             throw new Error("Failed to fetch data");
//           }

//           const data = await response.json();

//           const students = Array.isArray(data.students)
//             ? data.students.map((student) => ({
//                 id: student.student_id,
//                 Option1: student.student_name,
//                 Option2: student.student_roll_no,
//                 Option3: student.course_name,
//                 Headers1: "Student Name",
//                 Headers2: "Roll No",
//                 Headers3: "Course Name",
//               }))
//             : [];

//           return students; // Return the processed students to be used in the dropdown
//         } catch (error) {
//           console.error("Error fetching students and DPPs:", error);
//           return [];
//         }
//       } else {
//         return [];
//       }
//     };

//     const fetchChapterOptions = async (searchTerm) => {
//       if (searchTerm.length < 3) {
//         console.log("Search term must be at least 3 characters");
//         return []; // Do not fetch if search term is less than 3 characters
//       }

//       try {
//         console.log("Fetching chapters with search term:", searchTerm);

//         const response = await axios.post(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}&search_column=chapter`,
//           {
//             batch_ids: [],
//             assessment_ids: [],
//             subject_ids: [],
//             chapter_ids: [],
//           },
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const data = response.data;
//         console.log("API response data:", data);

//         // Merge chapter IDs (ensure unique chapter IDs)
//         const mergedChapters = mergeChapterOptions(data);
//         console.log("Merged chapter options:", mergedChapters);

//         // Filter options based on search term
//         const filteredChapters = mergedChapters.filter((option) =>
//           option.Option1.toLowerCase().includes(searchTerm.toLowerCase())
//         );

//         console.log("Filtered chapter options:", filteredChapters);
//         return filteredChapters;
//       } catch (error) {
//         console.error("Error fetching chapters:", error);
//         return [];
//       }
//     };

//     // Function to merge chapters with the same chapter ID
//     const mergeChapterOptions = (data) => {
//       const chapterMap = new Map();

//       data.forEach((item) => {
//         if (!chapterMap.has(item.chapter_id)) {
//           chapterMap.set(item.chapter_id, {
//             id: item.chapter_id,
//             Option1: item.chapter_name,
//             Option2: item.batch_name,
//             Option3: item.subject_name,
//             Headers1: "Chapter Name",
//             Headers2: "Batch Name",
//             Headers3: "Subject Name",
//           });
//         }
//       });

//       return Array.from(chapterMap.values());
//     };

//     const handleSelectedChapters = (selectedIds) => {
//       // Update selected chapter IDs
//       console.log("Selected chapter IDs:", selectedIds);
//       setSelectedChapters(selectedIds);
//     };

//     const handleApplyOrReset = async () => {
//       if (isApplied) {
//         // Reset only table data and headers
//         setResultsData([]); // Clear the table data
//         setHeaders([]); // Clear the headers
//         setIsApplied(false); // Set the state to not applied
//         setIsColumnDivVisible(false); // Optionally hide the column div if needed
//       } else {
//         // Apply logic
//         setIsApplied(true);
//         setDisabled(true);

//         let from_date, end_date;
//         const today = new Date();
//         const staticTime = "10:46:01.000";

//         if (value.month === "Last Month") {
//           from_date = format(
//             startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//             "yyyy-MM-dd"
//           );
//           end_date = format(
//             endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//             "yyyy-MM-dd"
//           );
//         } else if (value.month === "Month to Date") {
//           from_date = format(startOfMonth(today), "yyyy-MM-dd");
//           end_date = format(today, "yyyy-MM-dd");
//         } else if (value.month === "Week to Date") {
//           from_date = format(
//             startOfWeek(today, { weekStartsOn: 1 }),
//             "yyyy-MM-dd"
//           );
//           end_date = format(today, "yyyy-MM-dd");
//         } else if (value.month === "Custom") {
//           from_date = value.start_month;
//           end_date = value.end_month;
//         }

//         const from_date_with_time = `${from_date} ${staticTime}`;
//         const end_date_with_time = `${end_date} ${staticTime}`;

//         const postData = {
//           batch_ids: selectedBatchIds,
//           student_ids: selectedStudentIds,
//           subject_ids: value.subject_id,
//           chapter_ids: value.chapter_id,
//         };

//         try {
//           const response = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//               from_date_with_time
//             )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//             {
//               method: "POST",
//               headers: {
//                 accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify(postData),
//             }
//           );

//           const data = await response.json();
//           if (!response.ok) {
//             throw new Error("Failed to fetch report data");
//           }

//           if (data.length > 0) {
//             setHeaders(data[0]);
//             setResultsData(data.slice(1));
//           } else {
//             setResultsData([]); // Ensure table data is cleared if no results

//             setIsMessageBoxVisible(true);
//             setMessageBox(
//               <div
//                 className="Container-messageBOX"
//                 onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//                 onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//               >
//                 <div className="messagebox-insider1">
//                   <div className="loader-tc"></div>
//                   <span>No results found for the selected filters.</span>
//                 </div>
//                 <div className="messagebox-insider2">
//                   <button
//                     className="testreportcard-create-btn"
//                     onClick={() => setIsMessageBoxVisible(false)}
//                   >
//                     PROCEED
//                   </button>
//                 </div>
//               </div>
//             );
//             setActiveImg(InterogativeImg);
//           }
//           // setIsColumnDivVisible(true); // Show table when data is available
//         } catch (error) {
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div
//               className="Container-messageBOX"
//               onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//               onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//             >
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>{error.message}</span>
//               </div>
//               <div className="messagebox-insider2">
//                 <button
//                   className="messagebox-cancel-btn"
//                   style={{ marginRight: "10px" }}
//                   onClick={() => setIsMessageBoxVisible(false)}
//                 >
//                   CANCEL
//                 </button>
//                 <button
//                   className="testreportcard-create-btn"
//                   onClick={() => window.location.reload()}
//                 >
//                   PROCEED
//                 </button>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//       }
//     };

//     const handleRadioButtonChange = (selectedValue) => {
//       const today = new Date();

//       if (selectedValue === "Last Month") {
//         const firstDateLastMonth = startOfMonth(
//           new Date(today.getFullYear(), today.getMonth() - 1)
//         );
//         const lastDateLastMonth = endOfMonth(
//           new Date(today.getFullYear(), today.getMonth() - 1)
//         );
//         setValues({
//           ...value,
//           month: selectedValue,
//           start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//           end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//         });
//       } else if (selectedValue === "Month to Date") {
//         const firstDateOfCurrentMonth = startOfMonth(today);
//         setValues({
//           ...value,
//           month: selectedValue,
//           start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//           end_month: format(today, "yyyy-MM-dd"),
//         });
//       } else if (selectedValue === "Week to Date") {
//         const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//         setValues({
//           ...value,
//           month: selectedValue,
//           start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//           end_month: format(today, "yyyy-MM-dd"),
//         });
//       } else {
//         setValues({ ...value, month: selectedValue });
//       }
//     };

//     const handleCustomRangeChange = (e, field) => {
//       const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//       setValues({ ...value, [field]: formattedDate });
//     };

//     const dropdownStyle = isApplied
//       ? { opacity: 0.5, pointerEvents: "none" }
//       : { opacity: 1, pointerEvents: "auto" };

//     const data = resultsData.map((student) =>
//       headers.map((header, index) => student[index])
//     );

//     const course =
//       coursesdata && coursesdata.length > 0
//         ? coursesdata.find((course) => course.course_id === selectedCourseId)
//             ?.course_description || ""
//         : "";

//     const maxBatchLength = 136;
//     const batch = (() => {
//       if (
//         selectedBatchIds.length === 0 ||
//         selectedBatchIds.length === batchData.length
//       ) {
//         return "All"; // Case when no batches or all batches are selected
//       }

//       const batchString = batchData
//         .filter((batch) => selectedBatchIds.includes(batch.batch_id))
//         .map((batch) => batch.batch_name)
//         .join(", ");

//       if (batchString.length > maxBatchLength) {
//         return "Multiple";
//       } else {
//         return batchString;
//       }
//     })();

//     const maxStudentLength = 136;
//     const students = (() => {
//       if (
//         selectedStudentIds.length === 0 ||
//         selectedStudentIds.length === searchResults.length
//       ) {
//         return "All"; // Case when no students or all students are selected
//       }

//       const studentString = searchResults
//         .filter((student) => selectedStudentIds.includes(student.id))
//         .map((student) => student.label)
//         .join(", ");

//       if (studentString.length > maxStudentLength) {
//         return "Multiple";
//       } else {
//         return studentString;
//       }
//     })();

//     const maxSubjectLength = 136;
//     const subject = (() => {
//       if (
//         value.subject_id.length === 0 ||
//         value.subject_id.length === subjectData.length
//       ) {
//         return "All"; // Case when no subjects or all subjects are selected
//       }

//       const subjectString = subjectData
//         .filter((subject) => value.subject_id.includes(subject.id))
//         .map((subject) => subject.label)
//         .join(", ");

//       if (subjectString.length > maxSubjectLength) {
//         return "Multiple";
//       } else {
//         return subjectString;
//       }
//     })();

//     const maxChapterLength = 136;
//     const chapter = (() => {
//       if (
//         value.chapter_id.length === 0 ||
//         value.chapter_id.length === chapterData.length
//       ) {
//         return "All"; // Case when no chapters or all chapters are selected
//       }

//       const chapterString = chapterData
//         .filter((chapter) => value.chapter_id.includes(chapter.id))
//         .map((chapter) => chapter.label)
//         .join(", ");

//       if (chapterString.length > maxChapterLength) {
//         return "Multiple";
//       } else {
//         return chapterString;
//       }
//     })();

//     return (
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "36.5px",
//           marginBottom: "40px",
//         }}
//       >
//         <div style={{ position: "sticky", top: "0" }}>
//           <div className="Header-up">
//             <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//               DPP status summary
//             </span>
//             <div
//               className="testreportcard-header-btn-container"
//               style={{ marginRight: "30px" }}
//             >
//               <button
//                 className="testreportcard-cancel-btn"
//                 // onClick={handleCancel}
//                 onClick={() => navigate(-1)}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="testreportcard-create-btn"
//                 onClick={handleApplyOrReset}
//               >
//                 {isApplied ? "RESET" : "APPLY"}
//               </button>
//             </div>
//           </div>
//           <div
//             style={{
//               display: isVisible ? "block" : "none",
//               marginTop: "1vh",
//             }}
//           >
//             <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//               View, create, or filter reports. View and manage the list of
//               reports already available or create a new report.
//             </p>

//             {/* Dropdowns */}
//             <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`course_${resetKey}`}
//               >
//                 <DropDownCB
//                   label="Course"
//                   style={{ width: "13.5vw" }}
//                   selected={selectedCourseId}
//                   setSelected={setSelectedCourseId}
//                   options={
//                     coursesdata
//                       ? coursesdata.map((course) => ({
//                           id: course.course_id,
//                           label: course.course_description,
//                         }))
//                       : []
//                   }
//                   isUnique={BorderControl} // Pass the boolean value here to switch between classes
//                 />
//               </div>
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`batch_${resetKey}`}
//               >
//                 <DropDownMultipleSelection
//                   label="Batch"
//                   width="13.5vw"
//                   selected={selectedBatchIds}
//                   setSelected={setSelectedBatchIds}
//                   options={batchData.map((batch) => ({
//                     label: batch.batch_name,
//                     id: batch.batch_id,
//                   }))}
//                 />
//               </div>
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`student_${resetKey}`}
//               >
//                 <DropDownMultipleSearchSelection
//                   width="13.5vw"
//                   customWidth="25vw"
//                   label="Search Student"
//                   selected={selectedStudentIds} // Pass selected student IDs
//                   setSelected={setSelectedStudentIds} // Function to update selected student IDs
//                   fetchOptions={fetchStudentsAndDppByBatch} // Function to fetch student data from API
//                   showSelectAll={true} // Optionally show "Select All" checkbox
//                 />
//               </div>
//             </div>
//             <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`test_${resetKey}`}
//               >
//                 <DropDownMultipleSelection
//                   label="Subject"
//                   width="13.5vw"
//                   selected={value.subject_id}
//                   setSelected={(selectedOptions) =>
//                     setValues({ ...value, subject_id: selectedOptions })
//                   }
//                   options={subjectData}
//                 />
//               </div>
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`chapter_${resetKey}`}
//               >
//                 <DropDownMultipleSearchSelection
//                   width="13.5vw"
//                   customWidth="25vw"
//                   label="Select Chapters"
//                   selected={selectedChapters}
//                   setSelected={handleSelectedChapters}
//                   fetchOptions={fetchChapterOptions}
//                   showSelectAll={true}
//                   optionsData={chapterOptions}
//                 />
//               </div>
//             </div>
//           </div>
//           {/* Date Range and Table Component */}
//           <div
//             style={{
//               display: isVisible ? "block" : "none",
//               marginTop: "1vh",
//             }}
//           >
//             <div
//               className="grid-container-radio-button"
//               style={{ ...dropdownStyle }}
//             >
//               <div className="item5">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="last month"
//                     name="month"
//                     value="Last Month"
//                     checked={value.month === "Last Month"}
//                     onChange={() => handleRadioButtonChange("Last Month")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="last month">Last Month</label>
//                 </div>
//               </div>
//               <div className="item6">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="month to date"
//                     name="month"
//                     value="Month to Date"
//                     checked={value.month === "Month to Date"}
//                     onChange={() => handleRadioButtonChange("Month to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="month to date">Month to Date</label>
//                 </div>
//               </div>
//               <div className="item7">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="week to date"
//                     name="month"
//                     value="Week to Date"
//                     checked={value.month === "Week to Date"}
//                     onChange={() => handleRadioButtonChange("Week to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="week to date">Week to Date</label>
//                 </div>
//               </div>
//               <div className="item8">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="custom"
//                     name="month"
//                     value="Custom"
//                     checked={value.month === "Custom"}
//                     onChange={(e) =>
//                       setValues({ ...value, month: e.target.value })
//                     }
//                     disabled={disabled}
//                   />
//                   <label htmlFor="custom">Custom</label>
//                 </div>
//               </div>

//               {value.month === "Custom" && (
//                 <>
//                   <div className="item9">
//                     <FormInputs
//                       type="date"
//                       name="start_month"
//                       value={value.start_month}
//                       onChange={(e) =>
//                         setValues({ ...value, start_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                   <div className="item10">To</div>
//                   <div className="item11">
//                     <FormInputs
//                       type="date"
//                       name="end_month"
//                       value={value.end_month}
//                       onChange={(e) =>
//                         setValues({ ...value, end_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//           <div style={{ position: "relative", marginTop: "20px" }}>
//             <button
//               style={{
//                 position: "absolute",
//                 top: "-1px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 zIndex: 1,
//                 width: "60px",
//                 height: "10px",
//                 backgroundColor: "white",
//                 // borderTopLeftRadius: "100px",
//                 // borderTopRightRadius: "100px",
//                 border: "none",
//                 // borderBottom: "0px !important",
//               }}
//               onClick={() => {
//                 setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
//                 setIsVisible(!isVisible);
//               }}
//             >
//               <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//             </button>

//             <TableComponent
//               headers={headers.map((header) => header.substring(2))} // Pass headers state
//               data={resultsData} // Pass the processed API data
//               searchPlaceholder="Search by Student Name..."
//               isColumnDivVisible={isColumnDivVisible}
//               setIsColumnDivVisible={setIsColumnDivVisible}
//               dataClient={dataClient}
//               isExpanded={isExpanded} // Pass the new isExpanded prop
//               ReportPageHeader="Student DPP Summary"
//               course={course}
//               batch={batch}
//               student={students}
//               subject={subject}
//               chapter={chapter}
//               dppName={""}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }
// );

// export default StudentDPPSummary;

import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import TableCompoenent from "../components/TableCompoenent";
import { API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownCB from "../components/SingleDropdwon";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import { useNavigate } from "react-router-dom";
const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const StudentDPPSummary = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students

  const [headers, setHeaders] = useState([]);
  // const [chapterData, setChapterData] = useState([]);
  // const [batchData, setBatchData] = useState([]);
  // const [subjectData, setSubjectData] = useState([]);
  const [testnamedata, setTestNameData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  // const [selectedBatches, setSelectedBatches] = useState([]);
  // const [selectedDppIds, setSelectedDppIds] = useState([]);
  // const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
  const [selectedBatchName, setSelectedBatchName] = useState("");
  // const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  // const [studentData, setStudentData] = useState([]); // State to hold fetched students
  const [testname, setTestName] = useState([]); // This will store the fetched DPP names
  const [chapterName, setChapterName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
  // const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [apiData, setApiData] = useState([]);
  // const [selectedChapters, setSelectedChapters] = useState([]);

  const [searchKey, setSearchKey] = useState(""); // State for search key from CustomSearchDropdown
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]); // New state for student dropdown
  // const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [searchColumn, setSearchColumn] = useState(""); // search column
  const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName"); 
  // console.log('Received reportName:', reportName)
  
  // Modify fetchDropdownData to include selectedCourseId
  useEffect(() => {
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]); // Trigger fetchDropdownData when selectedCourseId changes

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
            assessment_ids: selectedDppIds,
            student_ids: selectedStudents,
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );

      const data = await response.json();

      setBatchData(
        mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      // Ensure unique chapters by chapter_id
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );

      setDppData(
        mapDataToDropdownFormat(
          data.assessment_list,
          "assessment_id",
          "assessment_name"
        )
      );
      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((item) => ({
          id: item.student_id,
          student_name: item.student_name, // Field for Student Name
          roll_number: item.roll_number, // Field for Roll Number
          batch_name: item.batch_name, // Field for Batch Name
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [
    selectedCourseId,
    selectedBatches,
    selectedSubjects,
    selectedChapters,
    selectedDppIds,
    selectedStudents,
    searchKey,
    searchColumn,
  ]);

  const handleDropdownClose = () => {
    fetchDropdownData();
  };
  // Trigger the debounced fetch function when any of the dependencies change
  // useEffect(() => {
  //   fetchDropdownData();
  // }, [
  //   searchKey,
  //   searchColumn,
  //   selectedBatches,
  //   selectedSubjects,
  //   selectedChapters,
  //   selectedDppIds,
  //   selectedStudents,
  //   fetchDropdownData,
  //   selectedCourseId
  // ]);

  const handleSearchKeyChange = (key, dropdownType) => {
    // For Chapter, DPP, and Student, check if at least 3 characters are typed
    if (
      dropdownType === "chapter" ||
      dropdownType === "dpp" ||
      dropdownType === "student"
    ) {
      if (key.length >= 3) {
        setSearchKey(key);
        setSearchColumn(dropdownType); // Use either 'chapter', 'dpp', or 'student'
      } else {
        setSearchKey(""); // Before 3 characters, do not search
        setSearchColumn("");
      }
    } else {
      // For other dropdowns (Batch, Subject, etc.), set searchKey and searchColumn to null
      setSearchKey("");
      setSearchColumn("");
    }
  };

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = today.format("YYYY-MM-DD HH:mm:ss");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Custom":
        const current_time = today.format("HH:mm:ss");
        from_date = `${value.start_month} 00:00:00`;
        end_date = `${value.end_month} ${current_time}`;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset only non-essential fields while keeping the selected filters
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsApplied(false); // Set the state to not applied
      setIsColumnDivVisible(false); // Hide the column div if necessary
      setDisabled(false); // Enable dropdowns
      setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

      // Retain the selected course, batch, chapter, subject, and date values
      setValues((prevValues) => ({
        ...prevValues,
        report_title: "",
        assessment_id: "",
        assessment_name: "",
        description: "",
        // Keep course, batch, chapter, subject, and date fields unchanged
        month: prevValues.month,
        start_month: prevValues.start_month,
        end_month: prevValues.end_month,
        course_id: prevValues.course_id,
        batch_id: prevValues.batch_id,
        subject_id: prevValues.subject_id,
        chapter_id: prevValues.chapter_id,
      }));
    } else {
      // Apply logic
      setIsApplied(true);
      setDisabled(true); // Disable dropdowns

      // Fetch the DPP Performance Data using selected filters
      const { from_date, end_date } = calculateDates(); // Use the calculateDates function to get date range

      if (!selectedCourseId) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please Select a Course</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }

      const requestBody = {
        // course_id: selectedCourseId || null, // Selected course ID
        batch_ids: selectedBatches || [], // Selected batch IDs
        subject_ids: selectedSubjects || [], // Selected subject IDs
        chapter_ids: selectedChapters || [], // Selected chapter IDs
        // student_ids: selectedStudents.map(student => student.id) || [], // Selected student IDs
        student_ids: selectedStudents || [],
        // from_date: from_date, // Start date
        // end_date: end_date, // End date
      };

      try {
        // const response = await fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary`, {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
            from_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody), // Send selected values in the request body
          }
        );

        const data = await response.json();
        if (data && data.length > 0) {
          setHeaders(data[0]); // Set headers
          setResultsData(data.slice(1)); // Set results
        } else {
          setResultsData([]);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No report data found for the selected filters.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        setResultsData([]);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };
  const navigate = useNavigate();

  const maxChapterLength = 136;
  const chapter = (() => {
    // If no chapters are selected, assume "All" chapters are selected
    if (
      value.chapter_id.length === 0 ||
      value.chapter_id.length === chapterName.length
    ) {
      return "All"; // Case when no chapters or all chapters are selected
    }

    // Get the full chapter string by joining selected chapters (if chapters are selected)
    const chapterString = chapterName
      .filter((chapter) => value.chapter_id.includes(chapter.id))
      .map((chapter) => chapter.label)
      .join(", ");

    if (chapterString.length > maxChapterLength) {
      // If the string exceeds the limit, show "Multiple"
      return "Multiple";
    } else {
      // If the length is within the limit, return the full string
      return chapterString;
    }
  })();

  const maxStudentLength = 129;
  const student = (() => {
    if (
      selectedStudents.length === 0 ||
      selectedStudents.length === studentData.length
    ) {
      return "All";
    }
    const studentString = selectedStudents
      .map((student) => `${student.roll_no}`)
      .join(", ");

    if (studentString.length > maxStudentLength) {
      return "Multiple";
    } else {
      return studentString;
    }
  })();

  const maxDppLength = 136;
  const dppName = (() => {
    if (
      selectedDppIds.length === 0 ||
      selectedDppIds.length === testname.length
    ) {
      return "All";
    }
    const dppString = testname
      .filter((dpp) => selectedDppIds.includes(dpp.id))
      .map((dpp) => dpp.label)
      .join(", ");

    if (dppString.length > maxDppLength) {
      return "Multiple";
    } else {
      return dppString;
    }
  })();

  const maxSubjectLength = 136;
  const subject = (() => {
    if (
      value.subject_id.length === 0 ||
      value.subject_id.length === subjectData.length
    ) {
      return "All";
    }

    const subjectString = subjectData
      .filter((subject) => value.subject_id.includes(subject.id))
      .map((subject) => subject.label)
      .join(", ");

    if (subjectString.length > maxSubjectLength) {
      return "Multiple";
    } else {
      return subjectString;
    }
  })();

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span style={{ color: "#2F2E40", fontSize: "30px", textTransform: "capitalize"}}>
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Course"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                  : []
              }
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            {/* <DropDownMultipleSelection
              label="Batch"
              width="13.5vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={filteredBatches} // Filtered batch data
              showSelectAll={true}
            /> */}
            <DropDownMultipleSelection
              label="Select Batch"
              width="13vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={batchData}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              isRequired={false}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`student_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Student"
              optionsData={studentData}
              selected={selectedStudents}
              setSelected={setSelectedStudents}
              placeholder="Search for Students..."
              headers={["Student Name", "Roll Number", "Batch Name"]}
              optionFields={{
                option1: "student_name",
                option2: "roll_number",
                option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="20vw"
            />
          </div>
        </div>
        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`chapter_${resetKey}`}
          >
            {/* <DropDownMultipleSearchSelection
              label="Chapter"
              width="13.5vw"
              customWidth="25vw"
              selected={value.chapter_id}
              setSelected={(selectedOptions) => {
                const selectedChapterDetails = chapterData.filter((chapter) =>
                  selectedOptions.includes(chapter.id)
                );
                setValues({
                  ...value,
                  chapter_id: selectedOptions, // Store the selected chapter IDs
                });
              }}
              fetchOptions={fetchChaptersBySubject}
              options={chapterData || []} // Display the chapter data
              showSelectAll={true}
            /> */}
            <CustomSearchDropdown
              label="Select Chapter"
              optionsData={chapterData}
              selected={selectedChapters}
              setSelected={setSelectedChapters}
              placeholder="Search for Chapter..."
              headers={["Chapter Name", "Subject Name"]}
              optionFields={{
                option1: "chapter_name",
                option2: "subject_name",
                // option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="20vw"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`dpp_${resetKey}`}
          ></div>
        </div>
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader="Student DPP Performance"
          course={
            coursesdata?.find((course) => course.course_id === value.course_id)
              ?.course_description || ""
          }
          batch={selectedBatchName}
          student={student}
          subject={subject}
          dppName={dppName}
          date={
            from_date &&
            end_date &&
            dayjs(from_date).isValid() &&
            dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                  end_date
                ).format("YYYY-MM-DD HH:mm:ss")}`
              : ""
          }
          chapter={chapter}
          isExpanded={isExpanded} // Pass the new isExpanded prop
        />
      </div>
    </div>
  );
};

export default StudentDPPSummary;
